import { useWidget } from "@/lib/hooks/use-widget";
import { BitcoinIcon, SquareArrowDownIcon } from "lucide-react";
import React from "react";

const Unfunded = () => {
  const { redirectUrl } = useWidget();

  const links = [
    {
      label: "Buy",
      icon: BitcoinIcon,
      url: `/dashboard/buy/`,
    },
    {
      label: "Receive",
      icon: SquareArrowDownIcon,
      url: `/dashboard/?receive=true`,
    },
  ];

  return (
    <div className="h-full flex flex-col justify-center items-center">
      <h2>Get your first crypto now</h2>

      <div className="flex gap-4 mt-4">
        {links.map(({ label, icon: Icon, url }) => (
          <a
            key={label}
            href={`${redirectUrl}${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-primary text-primary-foreground text-xs rounded-full text-center py-2 px-4 flex justify-center items-center gap-2"
          >
            <Icon size={24} />
            <span>{label}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Unfunded;
